import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";

interface UserAvatarProps {
  avatarUrl: string | null | undefined;
  displayName: string;
  className?: string;
}

export function getAvatarSrc(avatarUrl: string | null | undefined, userId?: string | null): string | undefined {
  if (!avatarUrl) return undefined;
  if (avatarUrl.startsWith("default:")) {
    const key = avatarUrl.replace("default:", "");
    return `/avatars/defaults/${key}.png`;
  }
  if (userId) {
    return `/api/avatar/${userId}`;
  }
  return undefined;
}

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return (name[0] || "?").toUpperCase();
}

export function UserAvatar({ avatarUrl, displayName, className }: UserAvatarProps) {
  const src = avatarUrl?.startsWith("default:")
    ? `/avatars/defaults/${avatarUrl.replace("default:", "")}.png`
    : avatarUrl
      ? undefined
      : undefined;

  return (
    <Avatar className={cn(className)}>
      {src && <AvatarImage src={src} alt={displayName} />}
      <AvatarFallback>{getInitials(displayName)}</AvatarFallback>
    </Avatar>
  );
}

interface UserAvatarWithIdProps extends UserAvatarProps {
  userId: string;
}

export function UserAvatarWithId({ avatarUrl, userId, displayName, className }: UserAvatarWithIdProps) {
  const src = getAvatarSrc(avatarUrl, userId);

  return (
    <Avatar className={cn(className)}>
      {src && <AvatarImage src={src} alt={displayName} />}
      <AvatarFallback>{getInitials(displayName)}</AvatarFallback>
    </Avatar>
  );
}
